import React, { useState } from 'react'
import { LntSelect } from '@app/components/base'
import { TopFilters as TopFiltersWrapper } from '@app/components'

import { objectHasNonNullableProp, objectMapValues } from '@app/utils/object'

import { FILTERS_PLACEHOLDERS } from '@app/constants/filters'
import { FILTERS_PARAMS_KEYS } from '@app/api/constants'
import { LOCATION_KEY, MONITORINGS_TYPES_KEY, MONITORINGS_SUBTYPES_KEY } from '@app/constants/queryKeys'

import { getTypes, getSubtypesTypes } from '@app/api/routes/monitorings'
import { getStores } from '@app/api/routes/locationStores'
import { getClusters } from '@app/api/routes/locationСlusters'
import { getClusterGroups } from '@app/api/routes/locationClusterGroups'
import { getSalesOrganization } from '@app/api/routes/locationSalesOrganization'

import { getFilterFromEntities } from '@app/utils/entitiesAdapters'

import { commonSelectProps } from './configs'

import type { TopFilterProps } from './types'

// TODO: нужен рефакторинг, вынести фильтры в новую сущность и переиспользовать в табах
export const TopFilters: React.FC<TopFilterProps> = ({ onSearch, initialFilters }) => {
  const [filters, setFilters] = useState(initialFilters)

  const handleSelectChange = (key: keyof typeof FILTERS_PARAMS_KEYS, value: any): void => {
    const updatedValue = value.length ? value : undefined

    setFilters(prev => ({ ...prev, [key]: updatedValue }))
  }

  const canResetFilters = (): boolean => {
    return objectHasNonNullableProp(filters)
  }

  const handleSearch = (): void => {
    onSearch(filters)
  }

  const handleClearFilters = (): void => {
    const clearedFilters = objectMapValues(filters, () => null)

    setFilters(clearedFilters)
  }

  return (
    <TopFiltersWrapper
      canReset={ canResetFilters() }
      onClear={ handleClearFilters }
      onSearch={ handleSearch }
    >
      <LntSelect
        { ...commonSelectProps }
        value={ filters.monitoringTypeIds }
        onChange={ value => handleSelectChange(FILTERS_PARAMS_KEYS.monitoringTypeIds, value) }
        placeholder={ FILTERS_PLACEHOLDERS.monitoringsTypeFilter }
        querySelect={ {
          queryKey: [MONITORINGS_TYPES_KEY.typesItems],
          queryFn: getTypes,
          select: getFilterFromEntities
        } }
      />

      <LntSelect
        { ...commonSelectProps }
        value={ filters.monitoringSubtypeIds }
        onChange={ value => handleSelectChange(FILTERS_PARAMS_KEYS.monitoringSubtypeIds, value) }
        placeholder={ FILTERS_PLACEHOLDERS.monitoringsSubtypesFilter }
        querySelect={ {
          queryKey: [MONITORINGS_SUBTYPES_KEY.subtypesItems],
          queryFn: getSubtypesTypes,
          select: getFilterFromEntities
        } }
      />

      <LntSelect
        { ...commonSelectProps }
        value={ filters.storeIds }
        onChange={ value => handleSelectChange(FILTERS_PARAMS_KEYS.storeIds, value) }
        placeholder={ FILTERS_PLACEHOLDERS.storesFilter }
        querySelect={ {
          queryKey: [LOCATION_KEY.locationStoresItems],
          queryFn: getStores,
          select: getFilterFromEntities
        } }
      />

      <LntSelect
        { ...commonSelectProps }
        value={ filters.clusterIds }
        onChange={ value => handleSelectChange(FILTERS_PARAMS_KEYS.clusterIds, value) }
        placeholder={ FILTERS_PLACEHOLDERS.clustersFilter }
        querySelect={ {
          queryKey: [LOCATION_KEY.locationClustersItems],
          queryFn: getClusters,
          select: getFilterFromEntities
        } }
      />

      <LntSelect
        { ...commonSelectProps }
        value={ filters.clustersGroupIds }
        onChange={ value => handleSelectChange(FILTERS_PARAMS_KEYS.clustersGroupIds, value) }
        placeholder={ FILTERS_PLACEHOLDERS.clusterGroupsFilter }
        querySelect={ {
          queryKey: [LOCATION_KEY.locationClusterGroupsItems],
          queryFn: getClusterGroups,
          select: getFilterFromEntities
        } }
      />

      <LntSelect
        { ...commonSelectProps }
        value={ filters.salesOrganizationIds }
        onChange={ value => handleSelectChange(FILTERS_PARAMS_KEYS.salesOrganizationIds, value) }
        placeholder={ FILTERS_PLACEHOLDERS.salesOrganizationFilter }
        querySelect={ {
          queryKey: [LOCATION_KEY.locationSalesOrganizationsItems],
          queryFn: getSalesOrganization,
          select: getFilterFromEntities
        } }
      />
    </TopFiltersWrapper>
  )
}
